import { CardTitle } from '@/components/Shares/CardTitle';
import { games } from '@/components/Shares/games';
import { useLingui } from '@lingui/react';
import { Grid, useMatches } from '@mantine/core';
import { CarouselImageItem } from '@/components/Shares/CarouselImageItem';
import { CategoryCard } from '@/components/Shares/CategoryCard';
import { Carousel } from '@mantine/carousel';
import { CarouselLayout } from '../../Shares/CarouselLayout';
import { statistics } from './data';
export const OverviewStatistic: React.FC = () => {
  const tops = games.find(item => item.id === 'tops');
  const {
    i18n
  } = useLingui();
  const titleIcon = useMatches({
    base: '/assets/title-icons/13.png',
    md: '/assets/title-icons/2.png'
  });
  return <Grid gutter={{
    base: 10,
    sm: 20
  }} mt={10}>
      <Grid.Col span={{
      base: 12,
      md: 6
    }}>
        <CarouselLayout id="game" title={<CardTitle firstText={i18n._('Favorite')} secondText={i18n._('Games')} isFirstGradient colorFrom="#FF5E9F" colorTo="#FF2E82" iconUrl={titleIcon} mt={6} />} items={tops?.items || []} slideSize={{
        base: '30%',
        sm: '22%',
        md: '30%',
        lg: '22%'
      }} isShadow>
          {tops?.items.map(item => <CarouselImageItem key={item.id} id={item.id} imgCard={item.imgCard} mobileWidth={128 / 135} desktopWidth={118 / 127} />)}
        </CarouselLayout>
      </Grid.Col>
      <Grid.Col span={{
      base: 12,
      md: 6
    }}>
        <CarouselLayout id="stats" items={statistics} slideSize={{
        base: '33%',
        sm: '25%'
      }} title={<CardTitle firstText={i18n._('Stats')} isFirstGradient colorFrom="var(--mantine-color-prime-0)" colorTo="var(--mantine-color-prime-0)" iconUrl="/assets/title-icons/12.png" mt={6} />}>
          {statistics.map(item => <Carousel.Slide key={item.title}>
              <CategoryCard w={{
            base: 116,
            sm: 155,
            md: 138
          }} p={6} {...item} />
            </Carousel.Slide>)}
        </CarouselLayout>
      </Grid.Col>
    </Grid>;
};